import { render, staticRenderFns } from "./CalculateYourTaxesDetail.vue?vue&type=template&id=fe66e048&scoped=true&lang=pug"
import script from "./CalculateYourTaxesDetail.vue?vue&type=script&lang=ts"
export * from "./CalculateYourTaxesDetail.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "fe66e048",
  null
  ,true
)

export default component.exports